// extracted by mini-css-extract-plugin
export default {"select":"StatusSelector_select__9+9vZ","divisor":"StatusSelector_divisor__43xcO"};